import React from 'react'

const AllDocumentList = () => {
  return (
   <section>
      <h1 className="text-center my-10 text-primary-red font-Calistoga text-2xl mb-5 underline">
        All Document List
      </h1>
      <h4 className='text-primary-red my-3 underline text-xl'>1 Darta & Original Document List </h4>

      <div className='flex justify-between'>
    <input className='file:bg-primary-red  file:text-white file:border-none file:rounded-full ' type="file" />
    <input placeholder='File Name' className='border border-primary-blue rounded-xl px-2 ' type="text" />
    <input className='bg-primary-blue px-2 py-1 rounded-full text-white hover:bg-primary-red cursor-pointer' type="submit" />
      </div>
      <table className="border-primary-blue min-w-full border my-5 text-center">
        <thead className="font-Bree bg-primary-red text-lg font-bold">
          <tr className="">
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              SN.
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Document Name
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Uploaded Staff Name
            </th>
      
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Action
            </th>
            
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Tick
            </th>
          </tr>
        </thead>
        <tbody>
          {" "}
          <tr className="">
            <td className=" text-primary-blue border border-primary-blue">1</td>
            <td className=" text-primary-blue border  border-primary-blue">
              ABC Company
            </td>
            <td className=" text-primary-blue border border-primary-blue">
              Bharatpur
            </td>
       
            <td className="flex gap-2 justify-center items-center p-2 text-sm">
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                View
              </button>
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                Download
              </button>
              <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
                Delete
              </button>
            </td>
            <td className=" text-primary-blue border border-primary-blue"><input type="checkbox" /></td>
            
          </tr>
        </tbody>
        <tbody>
          <tr></tr>
        </tbody>
      </table>
      <h4 className='text-primary-red my-3 underline text-xl'>2 Audit Report List </h4>

<div className='flex justify-between'>
<input className='file:bg-primary-red  file:text-white file:border-none file:rounded-full ' type="file" />
<input placeholder='File Name' className='border border-primary-blue rounded-xl px-2 ' type="text" />
<input className='bg-primary-blue px-2 py-1 rounded-full text-white hover:bg-primary-red cursor-pointer' type="submit" />
</div>
<table className="border-primary-blue min-w-full border my-5 text-center">
  <thead className="font-Bree bg-primary-red text-lg font-bold">
    <tr className="">
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        SN.
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Document Name
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Uploaded Staff Name
      </th>

      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Action
      </th>
      
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Tick
      </th>
    </tr>
  </thead>
  <tbody>
    {" "}
    <tr className="">
      <td className=" text-primary-blue border border-primary-blue">1</td>
      <td className=" text-primary-blue border  border-primary-blue">
        ABC Company
      </td>
      <td className=" text-primary-blue border border-primary-blue">
        Bharatpur
      </td>
 
      <td className="flex gap-2 justify-center items-center p-2 text-sm">
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          View
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Download
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Delete
        </button>
      </td>
      <td className=" text-primary-blue border border-primary-blue"><input type="checkbox" /></td>
      
    </tr>
  </tbody>
  <tbody>
    <tr></tr>
  </tbody>
</table>
<h4 className='text-primary-red my-3 underline text-xl'>3 Kar Chukta  List </h4>

<div className='flex justify-between'>
<input className='file:bg-primary-red  file:text-white file:border-none file:rounded-full ' type="file" />
<input placeholder='File Name' className='border border-primary-blue rounded-xl px-2 ' type="text" />
<input className='bg-primary-blue px-2 py-1 rounded-full text-white hover:bg-primary-red cursor-pointer' type="submit" />
</div>
<table className="border-primary-blue min-w-full border my-5 text-center">
  <thead className="font-Bree bg-primary-red text-lg font-bold">
    <tr className="">
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        SN.
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Document Name
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Uploaded Staff Name
      </th>

      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Action
      </th>
      
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Tick
      </th>
    </tr>
  </thead>
  <tbody>
    {" "}
    <tr className="">
      <td className=" text-primary-blue border border-primary-blue">1</td>
      <td className=" text-primary-blue border  border-primary-blue">
        ABC Company
      </td>
      <td className=" text-primary-blue border border-primary-blue">
        Bharatpur
      </td>
 
      <td className="flex gap-2 justify-center items-center p-2 text-sm">
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          View
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Download
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Delete
        </button>
      </td>
      <td className=" text-primary-blue border border-primary-blue"><input type="checkbox" /></td>
      
    </tr>
  </tbody>
  <tbody>
    <tr></tr>
  </tbody>
</table>
<h4 className='text-primary-red my-3 underline text-xl'>4 Word & Excel File List </h4>

<div className='flex justify-between'>
<input className='file:bg-primary-red  file:text-white file:border-none file:rounded-full ' type="file" />
<input placeholder='File Name' className='border border-primary-blue rounded-xl px-2 ' type="text" />
<input className='bg-primary-blue px-2 py-1 rounded-full text-white hover:bg-primary-red cursor-pointer' type="submit" />
</div>
<table className="border-primary-blue min-w-full border my-5 text-center">
  <thead className="font-Bree bg-primary-red text-lg font-bold">
    <tr className="">
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        SN.
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Document Name
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Uploaded Staff Name
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
       File Type
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Action
      </th>
      
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Tick
      </th>
    </tr>
  </thead>
  <tbody>
    {" "}
    <tr className="">
      <td className=" text-primary-blue border border-primary-blue">1</td>
      <td className=" text-primary-blue border  border-primary-blue">
        ABC Company
      </td>
      <td className=" text-primary-blue border border-primary-blue">
        Bharatpur
      </td>
      <td className=" text-primary-blue border border-primary-blue">
        PDF
      </td>
 
      <td className="flex gap-2 justify-center items-center p-2 text-sm">
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          View
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Download
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Delete
        </button>
      </td>
      <td className=" text-primary-blue border border-primary-blue"><input type="checkbox" /></td>
      
    </tr>
  </tbody>
  <tbody>
    <tr></tr>
  </tbody>
</table>
<h4 className='text-primary-red my-3 underline text-xl'>5 Other File List </h4>

<div className='flex justify-between'>
<input className='file:bg-primary-red  file:text-white file:border-none file:rounded-full ' type="file" />
<input placeholder='File Name' className='border border-primary-blue rounded-xl px-2 ' type="text" />
<input className='bg-primary-blue px-2 py-1 rounded-full text-white hover:bg-primary-red cursor-pointer' type="submit" />
</div>
<table className="border-primary-blue min-w-full border my-5 text-center">
  <thead className="font-Bree bg-primary-red text-lg font-bold">
    <tr className="">
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        SN.
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Document Name
      </th>
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Uploaded Staff Name
      </th>

      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Action
      </th>
      
      <th
        scope="col"
        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
      >
        Tick
      </th>
    </tr>
  </thead>
  <tbody>
    {" "}
    <tr className="">
      <td className=" text-primary-blue border border-primary-blue">1</td>
      <td className=" text-primary-blue border  border-primary-blue">
        ABC Company
      </td>
      <td className=" text-primary-blue border border-primary-blue">
        Bharatpur
      </td>
 
      <td className="flex gap-2 justify-center items-center p-2 text-sm">
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          View
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Download
        </button>
        <button className="bg-primary-blue hover:bg-primary-red px-2 py- my-1 rounded-3xl text-white">
          Delete
        </button>
      </td>
      <td className=" text-primary-blue border border-primary-blue"><input type="checkbox" /></td>
      
    </tr>
  </tbody>
  <tbody>
    <tr></tr>
  </tbody>
</table>
   </section>
  )
}

export default AllDocumentList